import { motion } from "framer-motion";

/* 
const strengths = [
  {
    icon: "corporate_fare",
    title: "직접 전송 방식",
    description: "이동통신사를 직접 거쳐 메시지를 발송하여 빠르고 안정적인 전송",
  },
  {
    icon: "call_split",
    title: "게이트웨이 이중화",
    description: "완벽한 이중화로 장애 리스크 없는 확실한 메시지 전달을 보장",
  },
  {
    icon: "bar_chart",
    title: "관리자 정산 시스템",
    description: "실시간으로 충전 · 사용 내역 · 타입별 통계를 확인 및 관리",
  },
  {
    icon: "dialpad",
    title: "015 발신번호 제공",
    description: "계약 후 별도 준비 없이 즉시 사용 가능한 015 번호 제공",
  },
];
*/

const strengthsData = [
  {
    id: "01",
    title: "직접 전송 방식",
    highlightText: "이동통신사를 직접 거쳐",
    normalText: " 메시지를 발송하여 빠르고 안정적인 전송이 가능합니다.",
    imgSrc: "/img/main/main_strength_01.png",
  },
  {
    id: "02",
    title: "게이트웨이 이중화",
    highlightText: "끊김 없는 이중화 시스템",
    normalText: "으로 리스크 없는 확실한 메시지 전달을 보장합니다.",
    imgSrc: "/img/main/main_strength_02.png",
  },
  {
    id: "03",
    title: "관리자 정산 시스템",
    highlightText: "충전 · 사용 내역 · 타입별 통계",
    normalText: "를 실시간으로 관리할 수 있는 서비스를 제공합니다.",
    imgSrc: "/img/main/main_strength_03.png",
  },
  {
    id: "04",
    title: "015 발신번호 제공",
    highlightText: "가입 즉시 발급되는 015 번호",
    normalText: "로 업무와 일상을 완벽하게 분리할 수 있습니다.",
    imgSrc: "/img/main/main_strength_04.png",
  },
];

const MainStrengthSection = () => {
  return (
    <section className="py-12 bg-white sm:py-16">
      <div className=" mx-auto max-w-container px-[2rem] wide:px-0">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.35 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
        >
          <p className="text-[2.5rem] font-medium text-[#2A2A2F]">
            2. 스탠다드 네트웍스만의 <strong>차별화된 강점</strong>
          </p>

          <div className="w-full mx-auto mt-10">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {strengthsData.map((item, index) => (
                <div key={item.title}>
                  <motion.div
                    initial={{ opacity: 0, y: 22 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.3 }}
                    transition={{ duration: 0.45, delay: index * 0.06, ease: "easeOut" }}
                    className="flex justify-between items-center rounded-[1.8rem] border border-[#dce6f6] bg-[#fbfdff] p-8 md:p-10 shadow-[0_6px_18px_rgba(35,67,130,0.04)] "
                  >
                    <div className="flex-1 pr-4">
                      <span className="inline-block text-std-blue font-bold bg-[#eef4ff] p-3 py-1.5 rounded-sm text-[1.8rem] mb-3">
                        {item.id}
                      </span>

                      {/* 제목 */}
                      <h3 className="text-[1.8rem] md:text-[2.3rem] font-bold text-std-black mb-3">
                        {item.title}
                      </h3>

                      {/* 설명문 */}
                      <p className="text-[1.4rem] md:text-[1.6rem] text-[#636776] leading-relaxed">
                        <span className="text-std-blue font-semibold">{item.highlightText}</span>
                        {item.normalText}
                      </p>
                    </div>

                    {/* 이미지 */}
                    <div className="w-40 h-40 md:w-48 md:h-48 flex-shrink-0 flex items-center justify-center">
                      <img
                        src={item.imgSrc}
                        alt={item.title}
                        className="w-full h-full object-contain"
                      />
                    </div>
                  </motion.div>
                </div>
              ))}
            </div>
          </div>

          {/* <div className="grid gap-4 mt-10 md:grid-cols-2 xl:grid-cols-4">
            {strengths.map((item, index) => (
              <motion.div
                key={item.title}
                initial={{ opacity: 0, y: 22 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.45, delay: index * 0.06, ease: "easeOut" }}
                className="rounded-[1.8rem] border border-[#dce6f6] bg-[#fbfdff] p-10 shadow-[0_6px_18px_rgba(35,67,130,0.04)]"
              >
                <div className="relative flex h-[5.2rem] w-[5.2rem] items-center justify-center rounded-[1.6rem] bg-gradient-to-br from-[#e5f0ff] via-[#d6e7ff] to-[#c9dcff] shadow-sm ring-1 ring-[#d3e2ff]">
                  <span className="material-icons-round text-[2.6rem] text-std-blue drop-shadow-sm">
                    {item.icon}
                  </span>
                </div>
                <h3 className="mt-4 text-[2rem] font-bold tracking-[-0.03em] text-[#1f2738]">
                  {item.title}
                </h3>
                <p className="mt-2 text-[1.6rem] leading-[1.7] text-[#66748c]">
                  {item.description}
                </p>
              </motion.div>
            ))}
          </div> */}
        </motion.div>
      </div>
    </section>
  );
};

export default MainStrengthSection;
